var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('app-home'),_c('app-approvals'),_c('app-project'),_c('app-solution'),_c('app-materials'),_c('app-news'),_c('app-team'),_c('Partners')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }